<template>
  <v-overlay
    :value="loading"
    :color="overlayColor"
    :absolute="absolute">
    <v-progress-circular
      indeterminate
      :color="circleColor"
      :size="circleSize"
      />
  </v-overlay>
</template>

<script>
import { mapGetters } from 'vuex'
import { STORE } from '@/constants'

const LOADING = `${STORE.APP.NAME}/${STORE.APP.LOADING}`

export default {
  props: {
    absolute: {
      type: Boolean,
      default: false
    },
    overlayColor: {
      type: String,
      default: 'white'
    },
    circleColor: {
      type: String,
      default: 'primary'
    },
    circleSize: {
      type: [String, Number],
      validator (v) {
        return !isNaN(Number(v))
      },
      default: 64
    }
  },

  computed: {
    ...mapGetters({
      loading: LOADING
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/Loading.vue